import { STABLE_PRICE } from '../constants';

import billingSummaryComponentUrl from './billingSummaryComponent.html';

class BillingSummaryCtrl {
  constructor(Authentication, PersonaCollection, SubscriptionUtils, Utils) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, SubscriptionUtils, Utils });
  }

  $onInit() {
    this.pricePerEmployee = this.Authentication.user.orgSettings.pricePerUser;
    this.businessPricePerEmployee = this.Authentication.user.orgSettings.businessPricePerUser;
    this.pricePerEmployeeYearly = this.Authentication.user.orgSettings.pricePerUserYearly;
    this.businessPricePerEmployeeYearly =
      this.Authentication.user.orgSettings.businessPricePerUserYearly;

    this.stablePrice = STABLE_PRICE;
    this.stablePricing = this.Authentication.user.orgSettings.premiumPricingType === 'stable';
  }

  get subtotal() {
    return this.SubscriptionUtils.getSubtotal(this.billingInfo, this.level, this.isYearly);
  }

  get pricePerUnit() {
    return this.SubscriptionUtils.getPricePerUnit(this.level, this.isYearly);
  }

  get proration() {
    return this.SubscriptionUtils.getProration(
      this.billingInfo,
      this.level,
      this.ignoreNextCharge,
      this.isYearly
    );
  }

  get discount() {
    return this.SubscriptionUtils.getDiscount(this.billingInfo, this.level);
  }

  get discountPercentage() {
    return this.billingInfo.discountPercentage;
  }

  get total() {
    return this.SubscriptionUtils.getTotal(
      this.billingInfo,
      this.level,
      this.ignoreNextCharge,
      this.isYearly
    );
  }

  get billingDate() {
    if (this.billingInfo.nextChargeDate) {
      return this.billingInfo.nextChargeDate;
    }

    const firstBillingAfterTrial = this.Utils.addDays(
      this.billingInfo.premiumTrialStartDate,
      this.Authentication.user.orgSettings.premiumTrialLength
    );
    const now = this.Utils.getNowDate();

    if (firstBillingAfterTrial.getTime() < now.getTime()) {
      return now;
    }

    return firstBillingAfterTrial;
  }
}

export default {
  bindings: {
    billingInfo: '<',
    level: '<',
    ignoreNextCharge: '<?',
    isYearly: '<',
    upgradeCost: '<?',
  },
  controllerAs: 'ctrl',
  controller: BillingSummaryCtrl,
  templateUrl: billingSummaryComponentUrl,
};
